import React, { useContext, useRef, useState } from "react";

import { t } from "app/utils";

import LazyEditor from "components/editor/LazyEditor";
import SelectTags from "components/post/SelectTags";
import { StoryModalContext } from "components/stories/video-studio/contexts/StoryContext";

const DetailsLazyEditor: React.FC<{}> = () => {
  const {
    changeSelectedBody,
    changeSelectedOptions,
    selectedBody,
    selectedOptions
  } = useContext(StoryModalContext);

  const [editorPadding, setEditorPadding] = useState({ paddingBottom: "55px" });

  const editorRef = useRef(null);

  const handleShareWithChanged = (newOptions: Record<string, any>[], selectHeight: number) => {
    changeSelectedOptions(newOptions);
    setEditorPadding({ paddingBottom: `${selectHeight + 35}px` });
  };

  const handleOnChange = (content: string) => changeSelectedBody(content);

  return (
    <div className="chq-ffd">
      <LazyEditor
        sections={["mention", "inlineStyleAndLink", "block", "undo"]}
        forzeOpen
        ref={editorRef}
        placeholder={t("Share your story here...")}
        onChange={handleOnChange}
        initialValue={selectedBody}
        style={editorPadding}
      />
      <SelectTags
        placeholder={t("Add tags to personalize your story")}
        selectedOptions={selectedOptions}
        onShareWithChanged={handleShareWithChanged}
        setEditorPadding={setEditorPadding}
        withOrgValues
      />
    </div>
  );
};

export default DetailsLazyEditor;
